function isObjectLike(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

export function normalizeVerificationDocuments(raw) {
  if (Array.isArray(raw)) {
    return raw.filter(isObjectLike);
  }

  if (isObjectLike(raw)) {
    // Accept either map/object or `{ items: [...] }` legacy-ish shapes.
    if (Array.isArray(raw.items)) {
      return raw.items.filter(isObjectLike);
    }

    return Object.values(raw).filter(isObjectLike);
  }

  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return normalizeVerificationDocuments(parsed);
    } catch {
      return [];
    }
  }

  return [];
}

export function findVerificationDocument(raw, kind) {
  const needle = String(kind || "").toLowerCase().trim();
  if (!needle) return null;

  const docs = normalizeVerificationDocuments(raw);
  for (let i = docs.length - 1; i >= 0; i -= 1) {
    const doc = docs[i];
    if (String(doc?.kind || "").toLowerCase().trim() === needle) {
      return doc;
    }
  }
  return null;
}

export function upsertVerificationDocument(raw, nextDoc) {
  if (!isObjectLike(nextDoc)) {
    return normalizeVerificationDocuments(raw);
  }

  const kind = String(nextDoc.kind || "").toLowerCase().trim();
  const docs = normalizeVerificationDocuments(raw);

  if (!kind) {
    return [...docs, nextDoc];
  }

  const next = docs.filter(
    (doc) => String(doc?.kind || "").toLowerCase().trim() !== kind
  );
  next.push(nextDoc);
  return next;
}
